const MODULE_URL = 'private_chat';

export default {
  MODULE_URL: MODULE_URL,
  SESSIONS_URL: MODULE_URL,

  SESSION_CREATED: 'private_chat_created',
  SESSION_REMOVED: 'private_chat_removed',
  SESSION_UPDATED: 'private_chat_updated',

  MESSAGE: 'private_chat_message',
  STATUS: 'private_chat_status',
};
